export const KEY_UP_ARROW = 38;
export const KEY_DOWN_ARROW = 40;
export const KEY_TAB = 9;
export const KEY_ENTER = 13;
export const KEY_SPACE = 32;
export const KEY_ESCAPE = 27;
